import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import CandidateInformation from "./CandidateInformation";
import InterviewDetails from "./InterviewDetails";
import ReportDetails from "./ReportDetails";

function InterviewState({
  jdDetails,
  interviewData,
  setInterviewData,
  interviewState,
  setInterviewState,
  jdId,
  iDronaId,
  userDetail,
  setLoading,
}) {
  console.log(interviewData);

  const [step2Enabled, setStep2Enabled] = useState(false);
  const [step3Enabled, setStep3Enabled] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [editFlag, setEditFlag] = useState(false);

  useEffect(() => {
    if (!interviewState || interviewState === "CONFIGURED") {
      setStep2Enabled(false);
      setStep3Enabled(false);
    } else if (
      interviewState === "INTERVIEW_SCHEDULED" ||
      interviewState === "INTERVIEW_EXPIRED"
    ) {
      setStep2Enabled(true);
      setStep3Enabled(false);
    } else if (interviewState === "INTERVIEW_COMPLETED") {
      setStep2Enabled(true);
      setStep3Enabled(true);
    }
  }, [interviewState]);

  const timelineItems = [
    {
      title: "Candidate Information",
      description: interviewData ? (
        <CandidateInformation
          interviewData={interviewData}
          setInterviewData={setInterviewData}
          interviewState={interviewState}
          setInterviewState={setInterviewState}
          step3Enabled={step3Enabled}
          editFlag={editFlag}
          setEditFlag={setEditFlag}
          jdId={jdId}
          iDronaId={iDronaId}
          userDetail={userDetail}
          setLoading={setLoading}
        />
      ) : null,
      enabled: true,
    },
    {
      title: "Interview details",
      description:
        interviewData && step2Enabled ? (
          <InterviewDetails
            interviewState={interviewState}
            setInterviewState={setInterviewState}
            editFlag={editFlag}
            step3Enabled={step3Enabled}
            interviewData={interviewData}
            setInterviewData={setInterviewData}
            jdId={jdId}
            iDronaId={iDronaId}
          />
        ) : null,
      enabled: step2Enabled && !editFlag,
    },
    {
      title: "Report details",
      description:
        interviewData && step3Enabled ? (
          <ReportDetails
            interviewData={interviewData}
            jdId={jdId}
            iDronaId={iDronaId}
          />
        ) : null,
      enabled: step3Enabled,
    },
  ];
  return (
    <div>
      <div className="relative sm:ml-4 ml-2 mt-2">
        {timelineItems.map((item, index) => (
          <div key={index} className="mb-7 relative">
            {index < timelineItems.length - 1 && (
              <div
                className={`absolute left-[9px]  top-[25px] w-[1.8px] h-[calc(98%)] rounded-[2px]
                  ${item.enabled ? "bg-[#EDC043]" : "bg-[#EAECF0]"}`}
              />
            )}
            <div className="flex items-start">
              <div className="sm:mr-[.8rem] mr-[.1rem] flex-shrink-0">
                <TimelineDot enabled={item.enabled} />
              </div>
              <div className={`flex-grow ${!item.enabled ? "opacity-50" : ""}`}>
                <div
                  className={`font-semibold text-[1rem] 
                    ${item.enabled ? "text-[#101828]" : "text-gray-500"}`}
                >
                  {item.title}
                </div>
                <div className="mt-2">{item.description}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const TimelineDot = ({ enabled }) => {
  if (enabled) {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
          fill="#EDC043"
        />
        <circle cx="12" cy="12" r="4" fill="white" />
      </svg>
    );
  }
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z"
        stroke="#EAECF0"
        strokeWidth="1.5"
      />
      <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
    </svg>
  );
};

export default InterviewState;
